import React, { useState, useEffect } from 'react'
import Sidebar from '../Sidebar/Sidebar';
import Products from '../Products/Products.js' 
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import './StepOne.scss';
import { hotDealsAtTop_NoDealOfTheMonth, sortProductsByPriceAndName } from '../../helpers/productSorters';

const mapStateToProps = (state) => ({
  currentlyEditing:       state.order.currentlyEditing,
  currentItem:            state.order.product,
  products:               state.product.balls,
  sortOrder:							state.app.sortOrder,
})

function StepOne(props) {

  const {events,products} = props;
  const [triggerRerender, setTriggerRerender] = React.useState(0);

  const [filteredProds, setFilteredProds] = useState(products);
  console.log("CURRENT PRODUCTS", products)
  const { t, i18n } = useTranslation();

  const curLanguage = i18n.language.toUpperCase();

  useEffect(()=>{

    console.log("SORT ORDER IS NOW", props.sortOrder);
    orderProducts(props.sortOrder)

  },[props.sortOrder])

  function filterProducts(oemArr) {
      setFilteredProds( 
      	hotDealsAtTop_NoDealOfTheMonth(
      		   sortProductsByPriceAndName(products.filter(prod => oemArr.includes(prod.BrandID)), props.sortOrder, curLanguage)
      	) 
      );
  }


  function orderProducts(order) {

  	let sortedProducts = hotDealsAtTop_NoDealOfTheMonth(sortProductsByPriceAndName(filteredProds, order, curLanguage));

    setFilteredProds(sortedProducts)

    setTriggerRerender(!triggerRerender)

  }

  return <div>
    <div className="container">
      <div className="row">
        <div className="col-lg-3 desktop-sidebar">
          <h3 className="text-uppercase">{t('Select Your Ball')}</h3>
          <Sidebar filterProducts={filterProducts} orderProducts={orderProducts} />
        </div>
        <div className="col-lg-9">
          <Products triggerRerender={triggerRerender} events={events} products={filteredProds} />
        </div>
      </div>
    </div>
  </div>

}

export default connect(mapStateToProps)(StepOne)